import logo from '../asset/logo.png';

const SignStyle = () => {
  return (
    <div className='sign-style'>
      <img src={logo} alt="Logo Al-Qur'an" className='logo-sign' />
      <p className='sign-style__title'>
        <span className='quran-text'>Qurtal</span> (Al-Qur'an Digital)
      </p>
      <p className='sign-style__hadits'>
        “Orang yang membaca Al-Qur’an dan ia mahir membacanya, maka kelak ia
        akan bersama para malaikat yang mulia lagi taat kepada Allah.” (HR.
        Bukhari Muslim);
      </p>
    </div>
  );
};

export default SignStyle;
